var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderRightDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44465 7.08008C9.75135 7.08008 9.99997 7.3287 9.99997 7.6354V14.5248C9.99997 14.8315 9.75135 15.0801 9.44465 15.0801H6.55529C6.24859 15.0801 5.99997 14.8315 5.99997 14.5248L5.99997 7.6354C5.99997 7.3287 6.24859 7.08008 6.55529 7.08008H9.44465Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4447 2.08008C16.7513 2.08008 17 2.3287 17 2.6354V14.5248C17 14.8315 16.7513 15.0801 16.4447 15.0801H13.5553C13.2486 15.0801 13 14.8315 13 14.5248V2.6354C13 2.3287 13.2486 2.08008 13.5553 2.08008H16.4447Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.4969H1.99997",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderRightDown);
export default ForwardRef;